const Label = ({ children, name, forHtml, classes }) => {
  return (
    <>
      <label className="ds-header__form-label" htmlFor={forHtml}>
        {name}
      </label>
      <div className="ds-header__form-input-wrapper">{children}</div>
    </>
  )
}

export default Label
